import { render, staticRenderFns } from "./Definicoes.vue?vue&type=template&id=6caca82b&scoped=true"
import script from "./Definicoes.vue?vue&type=script&lang=js"
export * from "./Definicoes.vue?vue&type=script&lang=js"
import style0 from "./Definicoes.vue?vue&type=style&index=0&id=6caca82b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6caca82b",
  null
  
)

export default component.exports